<template>
	<div class="v5-spinner-ios" :style="{ 'width':size, 'height':size }">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
</template>

<script>
	export default {
		name: 'v5-spinner-ios',
		props: {
			size: {
				type: String,
				default: '30px'
			}
		}
	};

</script>

<style lang="scss">
	@import '../style.scss';
	.v5-spinner-ios {
		display: inline-block;
		position: relative;
		div {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			&::before {
				content: '';
				display: block;
				margin: 0 auto;
				width: px2rem(4px);
				height: 24%;
				background-color: $color;
				animation: v5-spinner-ios 1s ease-in-out infinite;
			}
		}
		div:nth-child(2) {
			transform: rotate(36deg);
			&::before {
				animation-delay: -.9s;
			}
		}
		div:nth-child(3) {
			transform: rotate(72deg);
			&::before {
				animation-delay: -.8s;
			}
		}
		div:nth-child(4) {
			transform: rotate(108deg);
			&::before {
				animation-delay: -.7s;
			}
		}
		div:nth-child(5) {
			transform: rotate(144deg);
			&::before {
				animation-delay: -.6s;
			}
		}
		div:nth-child(6) {
			transform: rotate(180deg);
			&::before {
				animation-delay: -.5s;
			}
		}
		div:nth-child(7) {
			transform: rotate(216deg);
			&::before {
				animation-delay: -.4s;
			}
		}
		div:nth-child(8) {
			transform: rotate(252deg);
			&::before {
				animation-delay: -.3s;
			}
		}
		div:nth-child(9) {
			transform: rotate(288deg);
			&::before {
				animation-delay: -.2s;
			}
		}
		div:nth-child(10) {
			transform: rotate(324deg);
			&::before {
				animation-delay: -.1s;
			}
		}
		
	}

	@keyframes v5-spinner-ios {
		0%,
		39%,
		100% {
			opacity: .2;
		}
  		40% {
			opacity: 1;
		}
	}

</style>
